export class LoginModalService {
    constructor() {
        'ngInject';
        this.isOpen = false;
    }

    close() {
        this.isOpen = false;
    }

    open() {
        this.isOpen = true;
    }

    displayed() {
        return this.isOpen;
    }
}
